/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/BusinessSimulatorCashflowAccountReceivablesDistribution', 'model/BusinessSimulatorCashflowCapitalItemValuePaginationSlice', 'model/BusinessSimulatorCashflowSalesReceivablesDistribution', 'model/ForesightScenarioElementType', 'model/ForesightScenarioLevelReport', 'model/ForesightScenarioNotificationRecipient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./BusinessSimulatorCashflowAccountReceivablesDistribution'), require('./BusinessSimulatorCashflowCapitalItemValuePaginationSlice'), require('./BusinessSimulatorCashflowSalesReceivablesDistribution'), require('./ForesightScenarioElementType'), require('./ForesightScenarioLevelReport'), require('./ForesightScenarioNotificationRecipient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.ForesightScenarioReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.BusinessSimulatorCashflowAccountReceivablesDistribution, root.ForStractionServiceApi.BusinessSimulatorCashflowCapitalItemValuePaginationSlice, root.ForStractionServiceApi.BusinessSimulatorCashflowSalesReceivablesDistribution, root.ForStractionServiceApi.ForesightScenarioElementType, root.ForStractionServiceApi.ForesightScenarioLevelReport, root.ForStractionServiceApi.ForesightScenarioNotificationRecipient);
  }
}(this, function(ApiClient, BusinessSimulatorCashflowAccountReceivablesDistribution, BusinessSimulatorCashflowCapitalItemValuePaginationSlice, BusinessSimulatorCashflowSalesReceivablesDistribution, ForesightScenarioElementType, ForesightScenarioLevelReport, ForesightScenarioNotificationRecipient) {
  'use strict';




  /**
   * The ForesightScenarioReport model module.
   * @module model/ForesightScenarioReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>ForesightScenarioReport</code>.
   * @alias module:model/ForesightScenarioReport
   * @class
   */
  var exports = function() {
    var _this = this;


































  };

  /**
   * Constructs a <code>ForesightScenarioReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ForesightScenarioReport} obj Optional instance to populate.
   * @return {module:model/ForesightScenarioReport} The populated <code>ForesightScenarioReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Levels')) {
        obj['Levels'] = ApiClient.convertToType(data['Levels'], [ForesightScenarioLevelReport]);
      }
      if (data.hasOwnProperty('ElementTypes')) {
        obj['ElementTypes'] = ApiClient.convertToType(data['ElementTypes'], [ForesightScenarioElementType]);
      }
      if (data.hasOwnProperty('AccountReceivablesDistributions')) {
        obj['AccountReceivablesDistributions'] = ApiClient.convertToType(data['AccountReceivablesDistributions'], [BusinessSimulatorCashflowAccountReceivablesDistribution]);
      }
      if (data.hasOwnProperty('SalesReceivablesDistributions')) {
        obj['SalesReceivablesDistributions'] = ApiClient.convertToType(data['SalesReceivablesDistributions'], [BusinessSimulatorCashflowSalesReceivablesDistribution]);
      }
      if (data.hasOwnProperty('CapitalItemValues')) {
        obj['CapitalItemValues'] = BusinessSimulatorCashflowCapitalItemValuePaginationSlice.constructFromObject(data['CapitalItemValues']);
      }
      if (data.hasOwnProperty('NotificationRecipients')) {
        obj['NotificationRecipients'] = ApiClient.convertToType(data['NotificationRecipients'], [ForesightScenarioNotificationRecipient]);
      }
      if (data.hasOwnProperty('Name')) {
        obj['Name'] = ApiClient.convertToType(data['Name'], 'String');
      }
      if (data.hasOwnProperty('Description')) {
        obj['Description'] = ApiClient.convertToType(data['Description'], 'String');
      }
      if (data.hasOwnProperty('ChildrenTrackingLevelID')) {
        obj['ChildrenTrackingLevelID'] = ApiClient.convertToType(data['ChildrenTrackingLevelID'], 'Integer');
      }
      if (data.hasOwnProperty('MarketGrowth')) {
        obj['MarketGrowth'] = ApiClient.convertToType(data['MarketGrowth'], 'Number');
      }
      if (data.hasOwnProperty('CashflowReceivablesAmount')) {
        obj['CashflowReceivablesAmount'] = ApiClient.convertToType(data['CashflowReceivablesAmount'], 'Number');
      }
      if (data.hasOwnProperty('CashflowPayablesAmount')) {
        obj['CashflowPayablesAmount'] = ApiClient.convertToType(data['CashflowPayablesAmount'], 'Number');
      }
      if (data.hasOwnProperty('CashflowPastIndicatorID')) {
        obj['CashflowPastIndicatorID'] = ApiClient.convertToType(data['CashflowPastIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('CashflowFutureIndicatorID')) {
        obj['CashflowFutureIndicatorID'] = ApiClient.convertToType(data['CashflowFutureIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('SalesPastIndicatorID')) {
        obj['SalesPastIndicatorID'] = ApiClient.convertToType(data['SalesPastIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('SalesFutureIndicatorID')) {
        obj['SalesFutureIndicatorID'] = ApiClient.convertToType(data['SalesFutureIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('MaterialCostsPastIndicatorID')) {
        obj['MaterialCostsPastIndicatorID'] = ApiClient.convertToType(data['MaterialCostsPastIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('MaterialCostsFutureIndicatorID')) {
        obj['MaterialCostsFutureIndicatorID'] = ApiClient.convertToType(data['MaterialCostsFutureIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('TotalCostsPastIndicatorID')) {
        obj['TotalCostsPastIndicatorID'] = ApiClient.convertToType(data['TotalCostsPastIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('TotalCostsFutureIndicatorID')) {
        obj['TotalCostsFutureIndicatorID'] = ApiClient.convertToType(data['TotalCostsFutureIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('IsDefault')) {
        obj['IsDefault'] = ApiClient.convertToType(data['IsDefault'], 'Boolean');
      }
      if (data.hasOwnProperty('SimulateVAT')) {
        obj['SimulateVAT'] = ApiClient.convertToType(data['SimulateVAT'], 'Boolean');
      }
      if (data.hasOwnProperty('CashflowForecastInFromOperationsIndicatorID')) {
        obj['CashflowForecastInFromOperationsIndicatorID'] = ApiClient.convertToType(data['CashflowForecastInFromOperationsIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('CashflowForecastOutFromOperationsIndicatorID')) {
        obj['CashflowForecastOutFromOperationsIndicatorID'] = ApiClient.convertToType(data['CashflowForecastOutFromOperationsIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('CashflowForecastInvestmentsIndicatorID')) {
        obj['CashflowForecastInvestmentsIndicatorID'] = ApiClient.convertToType(data['CashflowForecastInvestmentsIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('CashflowForecastFinancialItemsIndicatorID')) {
        obj['CashflowForecastFinancialItemsIndicatorID'] = ApiClient.convertToType(data['CashflowForecastFinancialItemsIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('SalesMarginIndicatorID')) {
        obj['SalesMarginIndicatorID'] = ApiClient.convertToType(data['SalesMarginIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('GrossMarginIndicatorID')) {
        obj['GrossMarginIndicatorID'] = ApiClient.convertToType(data['GrossMarginIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('CashflowCutOffOverridenDate')) {
        obj['CashflowCutOffOverridenDate'] = ApiClient.convertToType(data['CashflowCutOffOverridenDate'], 'Date');
      }
      if (data.hasOwnProperty('NotifyAutomatically')) {
        obj['NotifyAutomatically'] = ApiClient.convertToType(data['NotifyAutomatically'], 'Boolean');
      }
      if (data.hasOwnProperty('NotificationCoverLetter')) {
        obj['NotificationCoverLetter'] = ApiClient.convertToType(data['NotificationCoverLetter'], 'String');
      }
      if (data.hasOwnProperty('OwnerID')) {
        obj['OwnerID'] = ApiClient.convertToType(data['OwnerID'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {Array.<module:model/ForesightScenarioLevelReport>} Levels
   */
  exports.prototype['Levels'] = undefined;
  /**
   * @member {Array.<module:model/ForesightScenarioElementType>} ElementTypes
   */
  exports.prototype['ElementTypes'] = undefined;
  /**
   * @member {Array.<module:model/BusinessSimulatorCashflowAccountReceivablesDistribution>} AccountReceivablesDistributions
   */
  exports.prototype['AccountReceivablesDistributions'] = undefined;
  /**
   * @member {Array.<module:model/BusinessSimulatorCashflowSalesReceivablesDistribution>} SalesReceivablesDistributions
   */
  exports.prototype['SalesReceivablesDistributions'] = undefined;
  /**
   * @member {module:model/BusinessSimulatorCashflowCapitalItemValuePaginationSlice} CapitalItemValues
   */
  exports.prototype['CapitalItemValues'] = undefined;
  /**
   * @member {Array.<module:model/ForesightScenarioNotificationRecipient>} NotificationRecipients
   */
  exports.prototype['NotificationRecipients'] = undefined;
  /**
   * @member {String} Name
   * @default ''
   */
  exports.prototype['Name'] = '';
  /**
   * @member {String} Description
   * @default ''
   */
  exports.prototype['Description'] = '';
  /**
   * @member {Integer} ChildrenTrackingLevelID
   */
  exports.prototype['ChildrenTrackingLevelID'] = undefined;
  /**
   * @member {Number} MarketGrowth
   * @default 0.0
   */
  exports.prototype['MarketGrowth'] = 0.0;
  /**
   * @member {Number} CashflowReceivablesAmount
   * @default 0.0
   */
  exports.prototype['CashflowReceivablesAmount'] = 0.0;
  /**
   * @member {Number} CashflowPayablesAmount
   * @default 0.0
   */
  exports.prototype['CashflowPayablesAmount'] = 0.0;
  /**
   * @member {Integer} CashflowPastIndicatorID
   * @default 0
   */
  exports.prototype['CashflowPastIndicatorID'] = 0;
  /**
   * @member {Integer} CashflowFutureIndicatorID
   * @default 0
   */
  exports.prototype['CashflowFutureIndicatorID'] = 0;
  /**
   * @member {Integer} SalesPastIndicatorID
   * @default 0
   */
  exports.prototype['SalesPastIndicatorID'] = 0;
  /**
   * @member {Integer} SalesFutureIndicatorID
   * @default 0
   */
  exports.prototype['SalesFutureIndicatorID'] = 0;
  /**
   * @member {Integer} MaterialCostsPastIndicatorID
   * @default 0
   */
  exports.prototype['MaterialCostsPastIndicatorID'] = 0;
  /**
   * @member {Integer} MaterialCostsFutureIndicatorID
   * @default 0
   */
  exports.prototype['MaterialCostsFutureIndicatorID'] = 0;
  /**
   * @member {Integer} TotalCostsPastIndicatorID
   * @default 0
   */
  exports.prototype['TotalCostsPastIndicatorID'] = 0;
  /**
   * @member {Integer} TotalCostsFutureIndicatorID
   * @default 0
   */
  exports.prototype['TotalCostsFutureIndicatorID'] = 0;
  /**
   * @member {Boolean} IsDefault
   * @default false
   */
  exports.prototype['IsDefault'] = false;
  /**
   * @member {Boolean} SimulateVAT
   * @default false
   */
  exports.prototype['SimulateVAT'] = false;
  /**
   * @member {Integer} CashflowForecastInFromOperationsIndicatorID
   * @default 0
   */
  exports.prototype['CashflowForecastInFromOperationsIndicatorID'] = 0;
  /**
   * @member {Integer} CashflowForecastOutFromOperationsIndicatorID
   * @default 0
   */
  exports.prototype['CashflowForecastOutFromOperationsIndicatorID'] = 0;
  /**
   * @member {Integer} CashflowForecastInvestmentsIndicatorID
   * @default 0
   */
  exports.prototype['CashflowForecastInvestmentsIndicatorID'] = 0;
  /**
   * @member {Integer} CashflowForecastFinancialItemsIndicatorID
   * @default 0
   */
  exports.prototype['CashflowForecastFinancialItemsIndicatorID'] = 0;
  /**
   * @member {Integer} SalesMarginIndicatorID
   * @default 0
   */
  exports.prototype['SalesMarginIndicatorID'] = 0;
  /**
   * @member {Integer} GrossMarginIndicatorID
   * @default 0
   */
  exports.prototype['GrossMarginIndicatorID'] = 0;
  /**
   * @member {Date} CashflowCutOffOverridenDate
   */
  exports.prototype['CashflowCutOffOverridenDate'] = undefined;
  /**
   * @member {Boolean} NotifyAutomatically
   * @default false
   */
  exports.prototype['NotifyAutomatically'] = false;
  /**
   * @member {String} NotificationCoverLetter
   * @default ''
   */
  exports.prototype['NotificationCoverLetter'] = '';
  /**
   * @member {Integer} OwnerID
   * @default 0
   */
  exports.prototype['OwnerID'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


